import createLazyComponent from '../LazyComponent';

const Unsubscribe = createLazyComponent(() => import('./UnsubscribePage'));

export default Unsubscribe;
